<template>
  <div>
    <h2>Please select the fields that will be spell checked when saving results:</h2>
    <checkbox
      v-for="field of fieldOptions"
      v-bind:key="field"
      :label="getLabel(field)"
      :name="field"
      :id="field + 'Checkbox'"
      :value="checkValue(field)"
      @input="updateValue(field)"
    />
    <SubmitCancelRow @submit="handleSubmit" @cancel="handleCancel" />
  </div>
</template>

<script>
import SubmitCancelRow from "./common/SubmitCancelRow.vue";
import Checkbox from "./common/Checkbox.vue";
import { startCase } from "lodash";
import { mapState } from "vuex";

export default {
  components: { SubmitCancelRow, Checkbox },
  props: ["initialFields"],
  data() {
    return {
      fieldOptions: ["diagnosis", "notes", "microscopic", "gross", "caseNotes", "clinical"],
      fieldsToSubmit: []
    };
  },
  mounted() {
    this.fieldsToSubmit = this.initialFields;
    if (this.UseSynopticTextField) {
      this.fieldOptions.push("synopticText");
    }
  },
  computed: {
    ...mapState({ UseSynopticTextField: state => state.labSettings.UseSynopticTextField })
  },
  methods: {
    handleSubmit() {
      this.$emit("submit", this.fieldsToSubmit);
    },
    handleCancel() {
      this.$emit("cancel");
    },
    checkValue(field) {
      return this.fieldsToSubmit.includes(field);
    },
    updateValue(field) {
      if (this.fieldsToSubmit.includes(field)) {
        this.fieldsToSubmit = this.fieldsToSubmit.filter(e => e !== field);
      } else {
        this.fieldsToSubmit.push(field);
      }
    },
    getLabel(field) {
      if (field === "notes") {
        return "Specimen Notes";
      }
      return startCase(field);
    }
  }
};
</script>

<style lang="scss" scoped></style>
